import {Injectable} from '@angular/core';
import {TokenService} from '@core/modules/authentication/services/token.service';
import {UserInfo} from '@core/modules/authentication/interfaces';
import {Roles} from '@core/modules/role/enums/roles.enum';
import {BehaviorSubject, Observable} from 'rxjs';
import {UserCurrent} from '@core/modules/authentication/interfaces/user-current.interface';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  constructor(private token: TokenService) { }

  private _userSubject: BehaviorSubject<UserCurrent> = new BehaviorSubject<UserCurrent>(undefined);

  set setUser(user: UserCurrent) {
    this._userSubject.next(user);
  }

  get getUser(): UserCurrent {
    return this._userSubject.getValue();
  }

  get getUser$(): Observable<UserCurrent> {
    return this._userSubject.asObservable();
  }

  public getUserFromToken(): UserInfo {
    try {
      return this.token.isToken ? JSON.parse(atob(this.token.getToken().split('.')[1])) : {};
    } catch (ignore) {
      return ({} as UserInfo);
    }
  }

  public getUserId(): number {
    return this.getUserFromToken().sub;
  }

  public getFullUsernameFromToken(): string {
    return this.getUserFromToken().username || 'Brak danych';
  }

  public getFirstNameFromToken(): string {
    return this.getFullUsernameFromToken().split(' ')[0] || '-';
  }

  public getSurnameFromToken(): string {
    return this.getFullUsernameFromToken().split(' ')[1] || '-';
  }

  public getRole(): Roles {
    try {
      return this.getUserFromToken().role.key;
    } catch (_ignore) {
      return undefined;
    }
  }

  public getRoleName(): string {
    try {
      return  this.getUserFromToken().role.name || '-';
    } catch (_ignore) {
      return '-';
    }
  }

  public getCompanyID(): number {
    return this.getUserFromToken().company_id;
  }

  public getCompanyName(): string {
    return this.getUserFromToken().company_name;
  }

  public isCurrentUser(id: number): boolean {
    return this.getUserId() === id;
  }

  public userSubjectReset(): void {
    this._userSubject = new BehaviorSubject<UserCurrent>(undefined);
  }
}
